export default __webpack_public_path__ + "static/media/cajascosecha.8ba17677.png";